// extracted by mini-css-extract-plugin
export default {"root":"StripeVerificationBanner_root__EFTYG","text":"StripeVerificationBanner_text__po6w3","link":"StripeVerificationBanner_link__52rnq"};